import axios from "axios";
import { getConfig } from "../config/config";

export async function getAllResearchs(token: string) : Promise<any> {
  try 
  {
    const response = await axios.get(
      getConfig().API_URL + "/pesquisas",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return {success: true, message:'', result: response.data.pesquisas};

  } catch (error: any) 
  {
    if(error)
      return {success: false, message: error.message};
  }

  return {success:false, message: 'Erro desconhecido. Tente novamente mais tarde.', result: ''};

}